import clsx from "clsx";
import { FC } from "react";

interface Props {
  fading?: boolean;
}

export const Divider: FC<Props> = ({ fading }) => (
  <div
    className={clsx(
      "flex h-4 flex-grow border-b-2 border-primary-25",
      fading && "opacity-50",
    )}
  />
);
